import React from 'react';
import { ChevronUpIcon } from '@heroicons/react/24/outline';

/**
 * 탑 버튼 컴포넌트
 * @description 버튼 클릭 시 화면 최상단으로 이동
 *
 */
const TopButton = () => {
  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    // 이미 맨 위에 있으면 실행하지 않음
    if (window.scrollY === 0) return;

    // 즉시 스크롤
    window.scrollTo(0, 0);

    // NOTE: 부드러운 스크롤이 필요한 경우 아래 코드 사용
    // window.scrollTo({
    //   top: 0,
    //   behavior: 'smooth',
    // });
  };

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-50 flex h-10 w-10 items-center justify-center rounded-full bg-purple5 text-white shadow-lg transition-all duration-300 hover:bg-purple6"
      aria-label="맨 위로 이동"
      type="button"
    >
      <ChevronUpIcon className="h-6 w-6" />
    </button>
  );
};

export default TopButton;
